import { Stack, StackProps, styled } from "@mui/material";

export const DialogBody: React.FC<StackProps> = styled(Stack)(({ theme }) => ({
  flexGrow: 1,
  gap: theme.spacing(2),
  maxWidth: theme.breakpoints.values.sm,
  width: "100%",
  [theme.breakpoints.up("md")]: {
    gap: theme.spacing(3),
  },
}));
